import { Container } from "reactstrap";
import ItemList from "../features/marketplace/ItemList";

const MarketPlace = () => {
    return (
        <Container>
            <ItemList />
        </Container>
      );
}
 

export default MarketPlace;